import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    containerbody: { width: '100%', minHeight: 'inherit', display: 'flex', flexDirection: 'column', position: 'relative' },
    buttonContainer: { display: 'flex', gap: '10px', padding: '20px', justifyContent: 'center' },
    loadingOverlay: {
        position: 'absolute',
        inset: 0,
        zIndex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: tokens.colorNeutralBackground1,
        pointerEvents: 'auto',
    },
});